// verification.schema.json source — `verification-profile.json` (spec §3.2
// workspace layout) + per-recipe evidence shape referenced by §5.3's result
// example (`evidence: [{recipe_id, report_path, sha256, exit_code}]`) and
// §5.4 "Verifier và commit ownership": "Chạy recipe từ verification-profile
// đã duyệt (argv/cwd/env scope/report parser rõ)."
import { z } from "zod";

// Exported (Bug G, P14): config-schema.ts's release.deploy_recipe/verify_recipe
// reuse this exact shape — same argv/cwd/env_allowlist/report_parser/report_glob
// contract a deploy or smoke-verify recipe needs, no new shape invented.
export const VerificationRecipeSchema = z
  .object({
    recipe_id: z.string().min(1),
    argv: z.array(z.string()).min(1),
    cwd: z.string().min(1),
    // Explicit env allowlist for the recipe subprocess — verifier subprocess
    // gets a restricted env too (§6.2: "Verifier chạy code/test của repo
    // cũng dùng env và sandbox hạn chế tương ứng").
    env_allowlist: z.array(z.string()),
    report_parser: z.enum(["json", "junit-xml", "text-exit-code"]),
    report_glob: z.string().min(1),
  })
  .strict();

export const VerificationProfileSchema = z
  .object({
    schema_version: z.literal(1),
    recipes: z.array(VerificationRecipeSchema).min(1),
    baseline_exceptions: z.array(
      z
        .object({
          recipe_id: z.string().min(1),
          reason: z.string().min(1),
          accepted_by: z.string().min(1),
          accepted_at: z.string().min(1),
        })
        .strict(),
    ),
  })
  .strict();

export const VerificationEvidenceSchema = z
  .object({
    recipe_id: z.string().min(1),
    report_path: z.string().min(1),
    sha256: z.string().regex(/^[0-9a-f]{64}$/i),
    exit_code: z.number().int(),
  })
  .strict();

export type VerificationProfile = z.infer<typeof VerificationProfileSchema>;
export type VerificationEvidence = z.infer<typeof VerificationEvidenceSchema>;
